import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
dayjs.locale('zh-cn')
export default {
  formatDate(date, format) {
    return dayjs(date).format(format)
  },
  // 计算序号
  getNewIndex(index, page, size) {
    return index + 1 + (page - 1) * size
  }
}
